import { useState } from "react";
import { Container, Snackbar, Alert } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import UserForm from "./UserFormProps";
import { FormValues } from "./types";
import { useNavigate } from 'react-router-dom';
import { ApiUrl } from '../App';
import { format } from 'date-fns/fp';

const App = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error",
  });

  const navigate = useNavigate();

    const handleSubmit = async (values: FormValues) => {
    try {
      // フォーム送信処理を擬似的に表現
//      await new Promise((resolve) => setTimeout(resolve, 100));
      	console.log(values); // フォームの値をログ出力
	const email = values.personalInfo.email;
	          console.log(email);
        console.log('----');
        const randomInt = Math.floor(Math.random() * 900000 + 100000);
        const n_password  = "x" + String(randomInt);
        console.log(n_password);

	const formData = new URLSearchParams();
        formData.append("email"   ,email);
        formData.append("password",n_password);
        const body = formData.toString();
        console.log(ApiUrl);

        const url = ApiUrl + "auth/email/register";
        console.log(url);

	fetch(url, {
                method: "POST",
                headers:{
                        'Content-Type': 'application/x-www-form-urlencoded'
                },
                body:  body,
             })
            .then(response => response.json())
            .then(data => {
	            console.log('Success:', data);
                    const fOk: boolean = data.success;
                    if ( fOk ) {
                        navigate('/number', {state:{
                                email    :  email,
                                password :  n_password
                        }})
                    }else{
                        console.log('in Error:', data);
                        console.log('in Error:', data.data.response);
                        navigate('/mes', { state:{
                                message: data.data.response,
                                }})
                    }
            })
            .catch((error) => {
                    console.error('Error:', error);
      			setSnackbar({
        			open: true,
        			message: "エラーが発生しました。",
        			severity: "error",
			})
	    })

    } catch (error) {
      setSnackbar({
        open: true,
        message: "エラーが発生しました。",
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

    return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Container maxWidth="sm">
        <UserForm onSubmit={handleSubmit} />
      </Container>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <br/>
      初めに上に入力いただいたメールアドレスに７桁の確認番号をお送りします。<br/>
      すぐに参照できるEメールのメールアドレスを入力してください。<br/>
      スマホのアドレス等でかまいませんが当社(@netv2.netvision.co.jp)からの<br/>
      メールを受信できるものにしてください。<br/>
      また、以下の当社プライバシーポリシーに同意いただいた上で登録を進めてくださ
い。<br/>
    <br/>
      <a href="https://secure.netvision.co.jp/new/company/priv.html">
      プライバシーポリシー</a><br/>
      <br/>
       メールアドレスを確認させて頂いた上で、応募フォームへ進みます。<br/>
       少々面倒な手順になっていますが、いたずらやハッキングアクセスが多いための<br/>
       セキュリティ上の対応ですので、ご理解ご協力をお願いします。<br/>
       そうしたシステムにより応募情報の保護を十分に行える形としています。<br/>
       <br/>
       <br/>
    </LocalizationProvider>
  );
};

export default App;
